import { Cache, createClient, defaultResponseHandler } from 'gqty';
import { generatedSchema, scalarsEnumsHash } from './schema.generated';
export const storageOrigin = () => ((typeof __JAEN_STORAGE_URL__ !== 'undefined' && __JAEN_STORAGE_URL__) ||
    'https://osg.snek.at').replace(/\/+$/, '');
export const storageFileUrl = (fileId) => `${storageOrigin()}/storage/${encodeURIComponent(fileId)}`;
const buildMultipartForm = (query, variables) => {
    const form = new FormData();
    const operations = { query, variables: structuredClone(variables ?? {}) };
    const map = {};
    const files = [];
    let index = 0;
    const setAt = (obj, path, value) => {
        let cursor = obj;
        for (let i = 0; i < path.length - 1; i++)
            cursor = cursor[path[i]];
        cursor[path[path.length - 1]] = value;
    };
    const walk = (value, path = []) => {
        if (value instanceof File || value instanceof Blob) {
            map[index] = [`variables.${path.join('.')}`];
            setAt(operations.variables, path, null);
            files.push({ index, file: value });
            index++;
        }
        else if (Array.isArray(value)) {
            value.forEach((item, i) => walk(item, [...path, i]));
        }
        else if (value && typeof value === 'object') {
            Object.entries(value).forEach(([key, val]) => walk(val, [...path, key]));
        }
    };
    walk(operations.variables);
    form.append('operations', JSON.stringify(operations));
    form.append('map', JSON.stringify(map));
    files.forEach(({ index: i, file }) => form.append(String(i), file));
    return form;
};
const queryFetcher = async ({ query, variables }, fetchOptions) => {
    const response = await fetch(`${storageOrigin()}/graphql`, {
        method: 'POST',
        body: buildMultipartForm(query, variables),
        mode: 'cors',
        ...fetchOptions
    });
    return await defaultResponseHandler(response);
};
export const osgCache = new Cache(undefined, {
    maxAge: Infinity,
    staleWhileRevalidate: 5 * 60 * 1000,
    normalization: true
});
export const osg = createClient({
    schema: generatedSchema,
    scalars: scalarsEnumsHash,
    cache: osgCache,
    fetchOptions: { fetcher: queryFetcher }
});
